import API from '../../util/api';

export default {
    login(payload) {
        return API.post('/member/login', payload);
    },

    loginToken(payload) {
        return API.post('/member/loginToken', payload);
    },

    loginKakao(access_token) {
        return API.post('/member/sns/kakao/login', {access_token: access_token});
    },

    signup(payload) {
        return API.post('/member/sign_up', payload);
    },

    signupKakao(payload) {
        return API.post('/member/sns/kakao/sign_up', payload);
    },

    signupPersonal(payload) {
        return API.post('/member/simple_sign_up', payload);
    },

    findId(payload) {
        return API.post('/member/find_id', payload);
    },

    findPw(payload) {
        return API.post('/member/find_pw', payload);
    },

    idCheck(id) {
        return API.post('/member/id_check', {id: id});
    },

    emailCheck(email) {
        return API.post('/member/email_check', {email: email});
    },

    getInfo() {
        return API.get('/member/info');
    },

    updateInfo(payload) {
        return API.patch('/member', payload);
    },

    deleteInfo() {
        return API.delete('/member');
    },

    inviteJoin(payload) {
        return API.post('/member/request/join', payload);
    },

    getInviteList() {
        return API.get('/member/request');
    },

    requestInviteList(payload) {
        return API.post('/member/request', payload);
    },

    phoneAuthentication(payload) {
        return API.post('/member/authentication', payload);
    },

    connectApplicant(unq_key) {
        return API.post('/member/connect_applicant', {unq_key: unq_key});
    },

    /**
     * 아이디/비밀번호 일치 여부 확인
     * @returns {Promise<boolean>}
     */
    passwordCheck({ id, password }) {
        return API.post('/member/password_check', { id, password }).then((res) => {
            const raw = res?.data;
            if (typeof raw === 'boolean') return raw;
            if (raw != null && typeof raw === 'object') {
                if (typeof raw.result === 'boolean') return raw.result;
                if (typeof raw.response === 'boolean') return raw.response;
            }
            if (raw === 1 || raw === '1' || raw === 'true') return true;
            return false;
        });
    }
};
